/**
 * Service for getting userdata
 */

import Backend from '../Backend'

/* @ngInject */
class UserData {

  static fetchAllUserSettings = () => {
    return Backend.getData(`/api/TAB_USERSETTINGS`)
      .then(res => {
        if (res.length === 0) {
          return {};
        }

        const settings = {}
        res.forEach((setting, idx) => {
          settings[setting.US_Key] = setting.US_Value
        })
        return settings
    })
  }

    static fetchMatrixUserSettings = () => {
    return Backend.getData(`/api/TAB_USERSETTINGS?US_Key=matrix`)
      .then(res => {
        if (res.length === 0) {
          return {};
        }
        return res[0].US_Value
    })
  }


    static saveMatrixSettings = (matrixType, courses) => {
    return Backend.getData(`/api/TAB_USERSETTINGS?US_Key=matrix`)
      .then(res => {
        if (res.length === 0) {
          // usersetting for matrix does not exist
          return this.createNewMatrixSettings(matrixType, courses)
        } else {
          // usersettings for matrix already exists

          return this.updateExistingMatrixSettings(res[0].US_ID, matrixType, courses)
        }
      })
  }

    static updateExistingMatrixSettings = (settingId, matrixType, courses) => {
    const payload = {
      US_Value: {
        type: matrixType,
        courses: courses,
      }
    }
    return Backend.putData(`/api/TAB_USERSETTINGS/${settingId}`, payload)
  }

    static createNewMatrixSettings = (matrixType, courses) => {
    const payload = {
      US_Key: 'matrix',
      US_Value: {
        type: matrixType,
        courses: courses
      }
    }
    return Backend.postData(`/api/TAB_USERSETTINGS/`, payload)
  }
}

export default UserData;